"use client";

import { useAuth } from "@/contexts/AuthProvider";
import { useSession } from "next-auth/react";
import { useWorkspaceCapabilities } from "@/contexts/WorkspaceCapabilitiesProvider";

export const useGetSession = () => {
  const { data: nextAuthSession, status } = useSession();
  const { me, loadingMe, errorMe, refreshMe } = useAuth();
  const workspaceCapabilities = useWorkspaceCapabilities();

  const isNextAuthAuthenticated = status === "authenticated";

  const isUserConnected = Boolean(me?.email); // or me?.id
  // Customer existence is historical billing data, not access authority.
  const isUserSubscribed =
    workspaceCapabilities.capabilities?.canUseAI ?? false;
  const isUserAdmin = (me?.role ?? "").toLowerCase() === "admin";
  const isCompanyOwner = isUserAdmin || me?.companyRole === "OWNER";
  const appToken = me?.company?.appToken ?? null;

  return {
    status,
    nextAuthSession,
    isNextAuthAuthenticated,

    me,
    loadingMe,
    errorMe,
    refreshMe,

    isUserConnected,
    isUserSubscribed,
    isUserAdmin,
    isCompanyOwner,
    appToken,
    workspaceCapabilities: workspaceCapabilities.capabilities,
    loadingWorkspaceCapabilities: workspaceCapabilities.loading,
    workspaceCapabilitiesError: workspaceCapabilities.error,
    refreshWorkspaceCapabilities: workspaceCapabilities.refresh,
  };
};
